import {Routes, Route, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import Menu from './menu/Menu'
import Link from './link/Link'
import SubMenu from './sub-menu/SubMenu'

export const menuManagementBreadCrumbs: Array<PageLink> = [
  {
    title: 'Menu Management',
    path: '/menu-management',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const MenuManagement = () => (
  <Routes>
    <Route
      element={
        <>
          {/* <ToolbarWrapper /> */}
          <Outlet />
        </>
      }
    >
      <Route
        path='menu'
        element={
          <>
            {/* <PageTitle breadcrumbs={menuManagementBreadCrumbs}>Menu</PageTitle> */}
            <Menu />
          </>
        }
      />
      <Route
        path='link'
        element={
          <>
            {/* <PageTitle breadcrumbs={menuManagementBreadCrumbs}>Menu</PageTitle> */}
            <Link />
          </>
        }
      />
      <Route
        path='submenu'
        element={
          <>
            {/* <PageTitle breadcrumbs={menuManagementBreadCrumbs}>Menu</PageTitle> */}
            <SubMenu />
          </>
        }
      />
      <Route index element={<Navigate to='/menu-management/menu' />} />
    </Route>
  </Routes>
)

export default MenuManagement
